import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetVideoStyle0 = gravityIconIndividualCss;

const GravityIconAssetVideo = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '9bd33ac7a373cf8e9a4bebd002c984f5d44109e4', color: this.color, size: this.size }, h("svg", { key: 'edec54d09c5a47aafdc7166fe95018ca0b9f0769', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '7c6255637ed03582d72723111fbd50d80cff869f', d: "M9 13.2V8.51a.3.3 0 0 1 .45-.26l4.41 2.47a.3.3 0 0 1 0 .53l-4.43 2.21A.29.29 0 0 1 9 13.2Z", fill: "currentColor" }), h("path", { key: '314c908780c8ff47a14e581c9d3696ca05375a3b', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 4a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-17Zm16 1.5v11h-15v-11h15Z", fill: "currentColor" }))));
    }
};
GravityIconAssetVideo.style = GravityIconAssetVideoStyle0;

export { GravityIconAssetVideo as gravity_icon_asset_video };

//# sourceMappingURL=gravity-icon-asset-video.entry.js.map